<template>
  <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row gutter="20" style="row-gap: 5px;">
            <el-col>
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <!-- <el-button class="btn button-with-icon" @click="addUser">
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/plus-icon.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/plus-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>ADD FACILITIES</span>
                  </el-button> -->
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  <div class="case-creation__step case-creation__Case-information">
    <div class="case-creation__card">
      <div class="case-creation__body pb-0" v-loading="loading">
        <el-row :gutter="15">
          <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Parent Lab</h4>
              <p class="value">{{ commercialSettingsData?.parent_lab?.name || "--" }}</p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Created At</h4>
              <p class="value">
                {{
                  momentWithTimezoneTime(
                    commercialSettingsData.created_at,
                    "MM-DD-yyyy"
                  ) || "--"
                }}
              </p>
            </div>
          </el-col>
          <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
            <div class="input-value view-cases">
              <h4 class="name">Updated At</h4>
              <p class="value">
                {{
                  momentWithTimezoneTime(
                    commercialSettingsData.updated_at,
                    "MM-DD-yyyy"
                  ) || "--"
                }}
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col >
            <div class="input-value view-cases">
              <h4 class="name">Facilities</h4>
              <ol v-if="commercialSettingsData?.facilities?.length">
                <li
                  v-for="value in commercialSettingsData.facilities"
                  :key="value.id || value.code"
                >
                  {{ value.code }} - {{ value.name }}
                </li>
              </ol>
              <p v-else>No facilities available</p>

            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("insurances", [
      "getCommercialFacilitiesByLabId",
    ]),
    ...mapGetters("auth", [
      "getUserPrimaryLabId",
    ]),
  },
  mounted() {
    this.fetchFacilitySettings();
  },
  data() {
    return {
      loading: false,
      commercialSettingsData: {},
    };
  },
  methods: {
    async fetchFacilitySettings() {
      try {
        this.loading = true;
        let labid
        if (this.getUserPrimaryLabId) {
          labid = this.getUserPrimaryLabId;
        }
        await this.$store.dispatch(
          "insurances/fetchCommercialFacilitiesByLabId",{labid}
        );
        this.commercialSettingsData = this.getCommercialFacilitiesByLabId;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
};
</script>
  <style lang="scss"></style>